const PROFILE_KEYS = ['omulongo_user_profiles_v1', 'omulongo_active_profile_id_v1'];
const OTHER_LOCAL_KEYS = ['omulongo_game_settings_v1'];

export async function resetLocalGameData(): Promise<void> {
  try {
    PROFILE_KEYS.forEach((key) => localStorage.removeItem(key));
    OTHER_LOCAL_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch {
    // best-effort
  }
}
